import { connect } from "react-redux";
import { getCommunications, getMonthlyWinsLeaders, getMonthlyWinningsLeaders, getSession } from "../selectors";
import MonthlyLeaderboard from "../components/monthly-leaderboard";
import { getMonthlyLeaders } from "../actions/monthly-leaderboard";

function select(state, props) {
  return {
    communications: getCommunications(state, props),
    monthlyWinningsLeaders: getMonthlyWinningsLeaders(state),
    monthlyWinsLeaders: getMonthlyWinsLeaders(state),
    session: getSession(state)
  };
}

export default connect(select, {onViewMonthlyLeaderboard: getMonthlyLeaders})(MonthlyLeaderboard);
